import React, { useState } from 'react';
import classNames from "classnames";

const InfoTable = ({ table }: any) => {

    const [copied, setCopied] = useState(false);

    const parseText = (text: string): any => {
        if (text.includes("rgba(") || text.includes("rgb(") || text === "transparent") {
            return <div className="w-6 h-6 border rounded" style={{ backgroundColor: text }}></div>
        }

        if (text === "current color" || text === "currentcolor") {
            return <div className="w-6 h-6 bg-white dark:bg-gray-800 border rounded"></div>
        }

        return text;
    };

    const copy = (tr: any): any => {
        // check for css classes
        const regex = /(\.([a-zA-Z_-]{1}[\w-_]+))/;
        let textToCopy = '';

        tr.map((td: string, index: Number) => {
            if (regex.test(td)) {
                textToCopy = td.substring(1);
            }
        })

        navigator.clipboard.writeText(textToCopy);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 1000);
    }

    return (
        <table className="w-full mb-4 bg-gray-100 dark:bg-gray-800 rounded">
            <tbody>
                {
                    table.map((tr: string[], index: Number) => {
                        return (
                            <tr className="group cursor-pointer" key={'tr-' + index} onClick={() => { copy(tr) }}>
                                {
                                    tr.map((td: string, index: Number) => {
                                        return (
                                            <td
                                                key={'td-' + index}
                                                className={classNames('font-mono text-xs p-2 border-b border-gray-300 dark:border-gray-700', {
                                                    'text-purple-700  dark:text-purple-500 whitespace-nowrap': index === 0,
                                                    'text-blue-700 dark:text-blue-500': index === 1,
                                                    'text-gray-500 dark:text-gray-300 text-xs': index === 2,
                                                })}>{parseText(td)}</td>
                                        );
                                    })
                                }
                                <td className="relative group-hover:opacity-100 opacity-0 font-mono text-xs p-2 border-b border-gray-300 dark:border-gray-700 cursor-pointer text-blue-600 dark:text-blue-500">
                                    <span className="absolute top-1/3 -translate-y-1/2 right-0">{copied ? 'copied' : 'copy'}</span>
                                </td>
                            </tr>
                        );
                    })
                }
            </tbody>
        </table>
    );
}

export default InfoTable;
